import React from "react";
import PropTypes from "prop-types";

/**
 * ProductList - horizontálny carousel na zobrazovanie produktov pre chatbota
 * @param {Object[]} products - Pole produktov [{ product_name, description, price, url, img_url }]
 * @param {string} [title] - Nadpis sekcie
 */
export default function ProductList({ products = [], title }) {
  if (!products.length) return null;
  const MAX_DESC_LENGTH = 90;
  return (
    <div style={{ margin: "16px 0" }}>
      {title && <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 10 }}>{title}</div>}
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          gap: 18,
          paddingBottom: 8,
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "thin",
        }}
      >
        {products.map((product, idx) => {
          const shortDesc =
            product.description && product.description.length > MAX_DESC_LENGTH
              ? product.description.slice(0, MAX_DESC_LENGTH) + "…"
              : product.description;
          return (
            <div
              key={idx}
              style={{
                minWidth: 220,
                maxWidth: 240,
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                padding: 14,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                border: "1px solid #f0f0f0",
                marginBottom: 2,
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
                <img
                  src={
                    product.img_url && product.img_url.trim()
                      ? product.img_url
                      : "https://gitlab2.4system.sk/infourad-obec/brekov-app/-/raw/master/public/assets/images/missing-photo.png?ref_type=heads"
                  }
                  alt={product.product_name}
                  style={{
                    width: 80,
                    height: 80,
                    objectFit: "contain",
                    borderRadius: 8,
                    background: "#f6f8fa",
                    border: "1px solid #eee",
                  }}
                  loading="lazy"
                />
              </div>
              <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 6, color: "#222" }}>
                {product.product_name}
              </div>
              <div style={{ fontSize: 14, color: "#555", marginBottom: 8, minHeight: 38 }}>
                {shortDesc}
              </div>
              <div style={{ fontWeight: 500, color: "#1976d2", fontSize: 15, marginBottom: 10 }}>
                {typeof product.price === "number"
                  ? `${product.price.toFixed(2)} €`
                  : product.price
                  ? `${product.price} €`
                  : ""}
              </div>
              <a
                href={product.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginTop: "auto",
                  background: "#1976d2",
                  color: "#fff",
                  borderRadius: 6,
                  padding: "8px 14px",
                  fontWeight: 600,
                  fontSize: 14,
                  textDecoration: "none",
                  transition: "background 0.15s",
                  display: "inline-block",
                }}
              >
                Zobraziť produkt
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
}

ProductList.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      product_name: PropTypes.string.isRequired,
      description: PropTypes.string,
      price: PropTypes.number,
      url: PropTypes.string,
      img_url: PropTypes.string,
    })
  ),
  title: PropTypes.string,
};
